// polyfills for IE
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'fast-text-encoding';

import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import { getPluginId } from './helpers';

ReactDOM.render(
  <App pluginId={getPluginId()} class="app" />,
  document.getElementById(process.env.REACT_APP_ROOT_ID)
);
